import { connect } from 'react-redux';
import ModalCloneFlow from './ModalCloneFlow';
import { cloneFlow } from '../../actions';
import { CLONE_FLOW_REQUEST } from '../../constants/actionTypes';

const mapStateToProps = (state) => {
  const { request } = state;
  return {
    loading: { cloneFlowRequest: !!request[CLONE_FLOW_REQUEST] },
  };
};

export default connect(mapStateToProps, { cloneFlow })(ModalCloneFlow);
